module.exports = __webpack_public_path__ + "img/icon-yellow-clock.89b10711.svg";